import { ref } from '@vue/composition-api'
import { getFeaturedCampaigns } from './featured.usecase'
import { announcementsUseCase } from '../../core/usecases'
import {useUserId} from '../../core/hooks'

const useFeatured = () => {
    const campaigns = ref([])
    const {userId} = useUserId()

    getFeaturedCampaigns().then( async res => {
        // show current user's campaigns at first
        let sortedArr = []
        res.forEach(item => {
            if(item._source.author_id === userId) {
                sortedArr = [item._source, ...sortedArr]
                return
            } 
            sortedArr = [...sortedArr, item._source]
        })

        const announcements = await announcementsUseCase.getFeaturedAnnouncements()

        campaigns.value = [...announcements, ...sortedArr]
    })

    announcementsUseCase

    return {
        campaigns
    }
}

export default useFeatured